module.exports = __webpack_public_path__ + "img/qx.72a63811.png";